import React, { ReactElement, ReactNode, useEffect, useState } from 'react';
import { Badge, Button, Col as ColBootstrap, Modal, Row } from 'react-bootstrap';
import { NombreLog, TypeNombre } from '../../../../../../common/src/entities/nombre-log.entity';
import { useFormikContext } from 'formik';
import { Entente } from '../../../../../../common/src/entities';
import ActiviteEntenteProduit from '../../../../../../common/src/entities/activite-entente-produit.entity';

type DetailsQuantitesActiviteEntenteProduitProps = {
    onConfirm: () => void;
};

export default function DetailsQuantitesActiviteEntenteProduit(
    props: DetailsQuantitesActiviteEntenteProduitProps,
): ReactElement {
    const { onConfirm } = props;
    const [nombreLogs, setNombreLogs] = useState<Partial<NombreLog>[] | undefined>();
    const [produits, setProduits] = useState<Partial<ActiviteEntenteProduit>[] | undefined>();
    const { values, setFieldValue } = useFormikContext<Entente>();

    // TODO pouvoir mettre plusieurs qte dans une même date
    // TODO bug le produit doit être enregistré avant de pouvoir ajouter des quantités. devrait pouvoir ajouter des quantités quand même
    // TODO pouvoir supprimer un nombre
    // TODO dates valides seulement
    // TODO empêcher mettre date < dans catégorie suivante... Ou pas?
    // TODO drag n drop pions

    useEffect(() => {
        const aep = values.activiteEntentes
            .map((ae) => (ae ? ae.activiteEntenteProduit : []))
            .flat()
            .map((aep) => ({ ...aep }))
            .filter(function (element) {
                return element !== null && element !== undefined;
            });

        setProduits(aep);

        setNombreLogs(
            aep
                .map((aep) => aep.nombreLogs)
                .flat()
                .map((nl) => ({ ...nl })),
        );
    }, [values.activiteEntentes]);

    function ajouterQuantite() {
        const quantite = parseInt(quantiteRef.current?.value ?? '0');
        const produit = quantiteProduitRef.current?.value;
        const type = typeQuantiteRef.current?.value as TypeNombre;
        let date = quantiteDateRef.current?.value;
        date =
            date != ''
                ? date
                : new Date().toLocaleDateString('en-CA', { timeZone: 'America/Toronto' }).replace(/\//g, '-');
        if (produit && quantite && type) {
            const aeIndex = values.activiteEntentes.findIndex(
                (ae) => ae.activiteEntenteProduit.findIndex((aep) => aep.id == parseInt(produit)) != -1,
            );
            if (aeIndex != -1) {
                const ae = [...values.activiteEntentes];
                const aepIndex = ae[aeIndex].activiteEntenteProduit.findIndex((aep) => aep.id == parseInt(produit));
                if (!ae[aeIndex].activiteEntenteProduit[aepIndex].nombreLogs) {
                    ae[aeIndex].activiteEntenteProduit[aepIndex].nombreLogs = [];
                }
                const sameDateIndex = ae[aeIndex].activiteEntenteProduit[aepIndex].nombreLogs.findIndex(
                    (nl) => nl.date_creation == date,
                );
                const data = {
                    name: type,
                    nombre: quantite,
                    date_creation: date,
                    notes: '',
                    fk_id_activite_entente_produit: ae[aeIndex].activiteEntenteProduit[aepIndex].id,
                } as NombreLog;
                if (sameDateIndex != -1) {
                    ae[aeIndex].activiteEntenteProduit[aepIndex].nombreLogs[sameDateIndex] = data;
                } else {
                    ae[aeIndex].activiteEntenteProduit[aepIndex].nombreLogs.push(data);
                }
                setFieldValue('activiteEntentes', ae);
            }
        }
    }

    function getNumCols() {
        if (!nombreLogs || !produits) return 0;

        const patchedNombreLogs = patchNombres(nombreLogs);
        if (!patchedNombreLogs) return 0;

        const dateCounts = {}; // Track unique dates per category
        let max = 0;

        for (const log of patchedNombreLogs) {
            for (const type of Object.keys(TypeNombre)) {
                const category = log.name; // Category type
                const date = log.date_creation; // Date

                if (category) {
                    if (!dateCounts[category]) {
                        dateCounts[category] = new Set();
                    }

                    dateCounts[category].add(date); // Store unique dates

                    max = Math.max(max, dateCounts[category].size); // Update max if needed
                }
            }
        }

        return max;
    }

    const numCols = getNumCols();

    function getLogsOfType(type: TypeNombre) {
        if (nombreLogs) {
            return patchNombres(nombreLogs)?.filter((n) => n.name == type);
        }
        return [];
    }

    const types = Object.entries(TypeNombre);

    //TODO pions
    const pionClient = <Badge style={{ backgroundColor: '#adffb0', color: 'white' }}>C</Badge>;
    const pionClientDiffus = <Badge style={{ backgroundColor: '#00ff08', color: 'white' }}>C</Badge>;
    const pionFournisseur = <Badge style={{ backgroundColor: '#bfc1ff', color: 'white' }}>F</Badge>;
    const pionFournisseurDiffus = <Badge style={{ backgroundColor: '#030bfc', color: 'white' }}>F</Badge>;

    const quantiteRef = React.createRef<HTMLInputElement>();
    const quantiteProduitRef = React.createRef<HTMLSelectElement>();
    const typeQuantiteRef = React.createRef<HTMLSelectElement>();
    const quantiteDateRef = React.createRef<HTMLInputElement>();

    const separator = (
        <>
            <br></br>
        </>
    );

    function deepCopyArray(arr: Partial<NombreLog>[]) {
        return arr.map((nl) => ({ ...nl }));
    }

    //ordre ascendant
    function sortByDate(a: Partial<NombreLog>, b: Partial<NombreLog>) {
        if (a.date_creation == b.date_creation) return 0;
        if (!a.date_creation) return -1;
        if (!b.date_creation) return 1;
        if (a.date_creation < b.date_creation) {
            return -1;
        }
        if (a.date_creation > b.date_creation) {
            return 1;
        }
        return 0;
    }

    function sortByDateDescendant(a: Partial<NombreLog>, b: Partial<NombreLog>) {
        if (a.date_creation == b.date_creation) return 0;
        if (!a.date_creation) return 1;
        if (!b.date_creation) return -1;
        if (a.date_creation < b.date_creation) {
            return 1;
        }
        if (a.date_creation > b.date_creation) {
            return -1;
        }
        return 0;
    }

    //Ajouter les nombres aux dates où il y a un nombre pour les autres produits (date format yyyy-mm-dd)
    function patchNombres(nombreLogs: Partial<NombreLog>[]) {
        const types = Object.entries(TypeNombre);
        let patchedLogs: Partial<NombreLog>[] | undefined;
        if (nombreLogs) {
            patchedLogs = deepCopyArray(nombreLogs);
            const nombreLogsSorted = nombreLogs.sort(sortByDate);
            const nombreLogsSortedDescendant = nombreLogs.sort(sortByDateDescendant);
            for (const nl of nombreLogsSorted) {
                if (produits) {
                    for (const produit of produits) {
                        if (nl.fk_id_activite_entente_produit != produit.id) {
                            if (
                                !patchedLogs.find(
                                    (l) =>
                                        l.date_creation == nl.date_creation &&
                                        l.fk_id_activite_entente_produit == produit.id,
                                )
                            ) {
                                //trouver la derniere quantité du log et l'ajouter à la date
                                let nombreLogsOfProduit = nombreLogsSortedDescendant
                                    .filter(
                                        (nlsd) =>
                                            nlsd.date_creation &&
                                            nl.date_creation &&
                                            nlsd.date_creation <= nl.date_creation,
                                    )
                                    .find((nl) => nl.fk_id_activite_entente_produit == produit.id);
                                if (!nombreLogsOfProduit) {
                                    nombreLogsOfProduit = nombreLogsSortedDescendant.find(
                                        (nl) => nl.fk_id_activite_entente_produit == produit.id,
                                    );
                                }
                                if (nombreLogsOfProduit) {
                                    patchedLogs.push({
                                        ...nombreLogsOfProduit,
                                        date_creation: nl.date_creation,
                                        name: nl.name,
                                    });
                                }
                            }
                        }
                    }
                }
            }
        }
        if (patchedLogs) {
            patchedLogs = patchedLogs.sort(sortByDate);
        }
        return patchedLogs;
    }

    return (
        <>
            <Modal.Header closeButton>
                <Modal.Title>Nombres</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h5>Nouvelle quantité</h5>
                <select id="quantiteProduit" ref={quantiteProduitRef}>
                    {produits && produits.map((t) => <option value={t.id}>{t.produit?.name}</option>)}
                </select>{' '}
                <input placeholder="Quantité" type="number" id="quantite" ref={quantiteRef} />{' '}
                <input
                    id="date"
                    placeholder={
                        'Date (' +
                        new Date().toLocaleDateString('en-CA', { timeZone: 'America/Toronto' }).replace(/\//g, '-') +
                        ')'
                    }
                    ref={quantiteDateRef}
                />{' '}
                <select id="quantiteType" ref={typeQuantiteRef}>
                    {/* TODO autoselect last type with a number */}
                    {types.map((t) => (
                        <option value={t[1]}>{t[0]}</option>
                    ))}
                </select>{' '}
                <Button onClick={() => ajouterQuantite()} variant="primary">
                    Ajouter
                </Button>
                {separator}
                {types.map((t) => {
                    const logs = getLogsOfType(t[1]);
                    const uniqueDates = logs?.filter(
                        (l, index, self) => index === self.findIndex((log) => log.date_creation === l.date_creation),
                    );
                    const numberOfLogs = uniqueDates?.length ?? 0;
                    return (
                        <>
                            <h5>{t[0]}</h5>
                            <Row>
                                <Col nbr={!uniqueDates || uniqueDates?.length == 0}></Col>
                                {uniqueDates?.map((l, i) => (
                                    <Col bt key={'a' + i}>
                                        <b>{l.date_creation}</b>
                                    </Col>
                                ))}
                                {[...Array(numCols - numberOfLogs)].map((_, i) => (
                                    <Col key={'b' + i} bt nbr nbb>
                                        &nbsp;
                                    </Col>
                                ))}
                                <Col last></Col>
                            </Row>
                            {produits?.map((p) => {
                                const filteredLogs = logs?.filter((l) => l.fk_id_activite_entente_produit == p.id);
                                return (
                                    <Row>
                                        <Col>{p.produit?.name}</Col>
                                        {filteredLogs?.map((l, i) => (
                                            <Col key={'a' + i}>{l.nombre}</Col>
                                        ))}
                                        {numCols - (filteredLogs?.length ?? 0) >= 0 &&
                                            [...Array(numCols - (filteredLogs?.length ?? 0))].map((_, i) => (
                                                <Col
                                                    nbb
                                                    nbr={numCols - (filteredLogs?.length ?? 0) == i + 1 ? false : true}
                                                ></Col>
                                            ))}
                                        <Col last>0 $</Col>
                                    </Row>
                                );
                            })}
                            {separator}
                        </>
                    );
                })}
                <h5>Légende</h5>
                {pionClientDiffus} Client diffusé {pionClient} Client pas diffusé {pionFournisseurDiffus} Fournisseur
                diffusé {pionFournisseur} Fournisseur pas diffusé
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onConfirm} variant="primary">
                    Confirmer
                </Button>
            </Modal.Footer>
        </>
    );
}

declare type NumberAttr = number | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12';
declare type ColOrder = 'first' | 'last' | NumberAttr;
declare type ColSize = boolean | 'auto' | NumberAttr;
declare type ColSpec =
    | ColSize
    | {
          span?: ColSize;
          offset?: NumberAttr;
          order?: ColOrder;
      };
type RowColProps = {
    children?: ReactNode;
    bl?: boolean;
    bt?: boolean;
    nbr?: boolean;
    nbb?: boolean;
    last?: boolean;
    brg?: boolean;
    md?: ColSpec;
};

function Col(props: RowColProps) {
    let borderSolid = '1px solid black';
    let borderLiquid = '1px solid #cccccc';
    let style: React.CSSProperties = { borderRight: borderSolid, borderBottom: borderSolid };
    if (props.bl) {
        style.borderLeft = borderSolid;
    }
    if (props.nbb) {
        style.borderBottom = borderLiquid;
        if (props.bt) {
            style.borderTop = borderLiquid;
        }
    } else if (props.bt) {
        style.borderTop = borderSolid;
    }
    if (props.nbr) {
        style.borderRight = borderLiquid;
    }
    if (props.last) {
        delete style.borderRight;
    }
    return (
        <ColBootstrap md={props.md} style={style}>
            {props.children}
        </ColBootstrap>
    );
}
